import React, { useEffect } from "react";
import { Grid, Typography, useTheme } from "@mui/material";
import TextLabel from "../../Common/CommonTextLabel";
import { makeStyles } from "tss-react/mui";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import CommonTextArea from "../CommonTextArea";
import ButtonOutlined from "../../Common/ButtonOutlined";
import ButtonContained from "../../Common/ButtonContained";
import CommonCheckBox from "../CommonCheckBox";
import { useSelector } from "react-redux";
import { checkAccess } from "../../../Utils/handler";
import { showLoader } from "../../../Redux/Slices/loaderSlice";
import { getAvailableAccess } from "../../../Redux/Actions/action";
import sessionStoreUtil from "../../../ApiSetup/Localstorage";

const useStyles = makeStyles()((theme) => {
  return {
    gridBorder: {
      background: theme.palette.secondary.main,
      border: `2px dashed ${theme.palette.bgLightBlack.main}`,
      padding: "10px", // Default value
      borderRadius: "12px",
    },
  };
});
const FinalizeDocuments = ({
  data,
  handleStatusChange,
  _updateMember,
  errors,
  validation,
  dataAccess,
}) => {
  //Hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { classes } = useStyles();
  const theme = useTheme();
  const { pathname } = useLocation();
  const startPathname = pathname?.split("-")[0];
  const user = sessionStoreUtil.getLSItem("userData")
    ? JSON.parse(sessionStoreUtil.getLSItem("userData"))
    : {};

  return (
    <Grid container item xs={12}>
      <Grid item xs={12}>
        <TextLabel
          fontSize={{ xs: "16px", md: "20px" }}
          fontWeight={600}
          color="#3E4094"
          title={"Finalize Process"}
          marginBottom={1}
        />
      </Grid>

      <Grid container spacing={1}>
        {checkAccess(startPathname, dataAccess, "Permanent Disable Action") && (
          <Grid item xs={12}>
            <CommonCheckBox
              handleChange={(e) => {
                handleStatusChange("permanentDisable", null, e.target.checked);
              }}
              checkBoxSize={"medium"}
              fontSize={{ lg: "16px", md: "15px", xs: "14px" }}
              text={"Not Eligible for Suraksha Kavach (Permanent Disable)."}
              sx={{ color: "#3E4094" }}
              checked={data?.permanentDisable ? true : false}
              value={data?.permanentDisable}
              disabled={user?.organisationName !== "PPSK"}
            />
            <Typography variant="body2" color="orange" gutterBottom>
              Note: This user will not eligible for Suraksha Kavach if you
              submit with permanent disablement criteria.
            </Typography>
          </Grid>
        )}

        {checkAccess(startPathname, dataAccess, "Permanent Disable Action") &&
          data?.permanentDisable && (
            <Grid item xs={12}>
              <CommonTextArea
                label="Reason"
                value={data?.permanentDisableReason}
                labelSize={{ lg: "14px", md: "14px", xs: "14px" }}
                name="permanentDisableReason"
                onChange={(e) =>
                  handleStatusChange(
                    "permanentDisableReason",
                    null,
                    e.target.value
                  )
                }
                rows={2}
                disabled={user?.organisationName !== "PPSK"}
              />
              <TextLabel
                color="error"
                title={
                  data?.permanentDisable && !data?.permanentDisableReason
                    ? errors?.permanentDisableReason
                    : ""
                }
              />
            </Grid>
          )}
        {user?.organisationName == "PPSK" && (
          <Grid item xs={12}>
            <CommonCheckBox
              handleChange={(e) => {
                handleStatusChange("isAgree", null, e.target.checked);
              }}
              checkBoxSize={"medium"}
              fontSize={{ lg: "16px", md: "15px", xs: "14px" }}
              text={"Agree with process"}
              sx={{ color: "#3E4094" }}
              checked={data?.isAgree ? true : false}
              value={data?.isAgree}
            />
            <TextLabel
              color="error"
              title={!data?.isAgree ? errors?.isAgree : ""}
            />
          </Grid>
        )}
        {user?.organisationName === "PPSK" && (
          <Grid
            item
            xs={12}
            display={"flex"}
            justifyContent={"flex-end"}
            gap={1}
          >
            <ButtonOutlined
              width={"auto"}
              text={"Cancel"}
              color={"#3E4094"}
              lineHeight={"24.5px"}
              backgroundColor={"#fff"}
              border={"1px solid #3E4094"}
              padding={{ xs: "5px 10px", md: "10px 20px" }}
              fontSize={{ xs: "12px", md: "14px" }}
              height={{ xs: "40px", sm: "40px" }}
              onClick={() => {
                if (data?.verificationStatus === "Approved") {
                  navigate("/documents-view-status");
                } else if (data?.verificationStatus === "Pending") {
                  navigate("/documents");
                } else {
                  navigate("/documents-view-status");
                }
              }}
            />

            <ButtonContained
              width={"auto"}
              text={"Confirm"}
              lineHeight={"24.5px"}
              padding={{ xs: "5px 10px", md: "10px 20px" }}
              fontSize={{ xs: "12px", md: "14px" }}
              height={{ xs: "40px", sm: "40px" }}
              onClick={() => {
                if (validation()) {
                  _updateMember("documents");
                }
              }}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default FinalizeDocuments;
